var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
var SVGIcon = styled.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    polygon {\n        ", "\n    }\n"], ["\n    polygon {\n        ",
    "\n    }\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                fill: ", ";\n            "], ["\n                fill: ", ";\n            "])), theme.colorControlIconDisabled);
});
export var NodeExpandedIcon = function (_a) {
    var disabled = _a.disabled, rest = __rest(_a, ["disabled"]);
    return (React.createElement(SVGIcon, { "data-selector-id": rest['data-selector-id'], viewBox: "0 0 10 6.409", width: "10px", height: "6.409px", disabled: disabled },
        React.createElement("polygon", { fill: "#444444", points: "10 1.414 8.588 0 5 3.594 1.412 0 0 1.414 4.998 6.409 10 1.414" })));
};
export var NodeCollapsedIcon = function (_a) {
    var disabled = _a.disabled, rest = __rest(_a, ["disabled"]);
    return (React.createElement(SVGIcon, { "data-selector-id": rest['data-selector-id'], viewBox: "0 0 6.409 10", width: "6.409px", height: "10px", disabled: disabled },
        React.createElement("polygon", { fill: "#444444", points: "1.414 0 0 1.412 3.594 5 0 8.588 1.414 10 6.409 5.002 1.414 0" })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=arrowIcons.js.map